exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".border-hearder[data-v-1b85e906]{border-color:#dfe6ec!important;margin-top:-1px}.pdfIcon[data-v-1b85e906]{width:50px;height:50px}.evidence-Dropdown[data-v-1b85e906]{width:172px}.commentContent[data-v-1b85e906]{white-space:pre;-ms-word-wrap:break-word;white-space:pre-wrap;white-space:-moz-pre-wrap;white-space:-o-pre-wrap;word-wrap:break-word}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"id":"data-v-1b85e906","scoped":true,"hasInlineConfig":false}!./~/postcss-loader/lib!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/common/EvidenceDialog.vue
// module id = 529
// module chunks = 1